<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->

        <div v-if="popUpType == 'viewDeals'">

          <div class="modal-backdrop">
            <div class="card col-lg-10 col-md-8 mt-md-4 col-11 p-0">

              <div class="postmodalcontent">

                <div class="modal-header borderbottom p-4">

                  <button type="button" class="close" @click="closepopup" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body bodymodal11">
                  <nav class="navbar navbar-expand-lg bg-info text-white">
                    <span><b>Update Deals {{ "- " + displayLeaseNumber }}</b></span>
                  </nav>
                  <br>
                  <center><span :style="msgcolor"><b>{{ message }}</b></span></center>
                  <br>

                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 py-2 mx-0">
                    <div class="col-12 col-md-12 d-flex justify-content-lg-between align-items-center">
                      <label for="year" class="col-form-label col-form-label-sm">Year</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center">
                      <input type="text" id="year" name="year" v-model="applicationData.year"
                        class="form-control input-sm" />
                    </div>

                    <div class="col-12 col-md-12 d-flex justify-content-lg-between align-items-center">
                      <label for="make" class="col-form-label col-form-label-sm">Make</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center">
                      <input type="text" id="make" name="Make" v-model="applicationData.make"
                        class="form-control input-sm" />
                    </div>

                    <div class="col-12 col-md-12 d-flex justify-content-lg-between align-items-center">
                      <label for="model" class="col-form-label col-form-label-sm">Model</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center">
                      <input type="text" id="model" name="Model" v-model="applicationData.model"
                        class="form-control input-sm" />
                    </div>

                  </div>

                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 py-2 mx-0">

                    <div class="col-12 col-md-12  d-flex justify-content-lg-between align-items-center">
                      <label for="source" class="col-form-label col-form-label-sm required"> Source </label>
                    </div>
                    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                      <select name="source" ref="source" v-model="applicationData.source" class="form-control input-sm"
                        data-vv-as="Source"
                        @change="retrieveAllDealers(applicationData.source, selectedEmployeeData.employeeId)">
                        <option disabled value=""> Select a Source </option>
                        <option v-for="(option, index) in sources" :value="option.sourceName" :key="index">{{
          option.sourceName }}</option>
                      </select>
                    </div>

                    <div class="col-12 col-md-12 d-flex justify-content-lg-between align-items-center">

                      <label for="customerName" class="col-form-label col-form-label-sm">Customer Name</label>
                    </div>
                    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                      <multiselect style="width:100%" v-model="selectedCustomerData" :options="appCustomersList"
                        :value="appCustomersList.customerId" :custom-label="displayCustomerFullName"
                        @input="getCustomerDetails(selectedCustomerData.customerId)" selected="selected"
                        id="customersdd">
                      </multiselect>
                    </div>

                    <div class="col-12 col-md-12 d-flex justify-content-lg-between align-items-center">
                      <label for="dealerName" class="col-form-label col-form-label-sm">Dealer Name</label>
                    </div>
                    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">

                      <multiselect style="width:100%" v-model="selectedDealerData" :options="sortedDealers"
                        :value="sortedDealers.dealerId" :custom-label="displayDealerFullName" selected="selected"
                        id="customersdd">
                      </multiselect>

                    </div>

                  </div>

                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 py-2 mx-0">
                    <div class="col-12 col-md-12  d-flex justify-content-lg-between align-items-center">
                      <label for="creditAnalyst" class="col-form-label col-form-label-sm required"> Underwriter Name</label>
                    </div>
                    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                      <multiselect style="width:100%" name="creditAnalyst" ref="creditAnalyst"
                        v-model="selectedCreditAnalystData" :options="creditAnalystList"
                        :value="creditAnalystList.employeeId" :custom-label="displayFullName" selected="selected"
                        id="creditAnalyst">
                      </multiselect>
                    </div>
                    <div class="col-12 col-md-12 d-flex justify-content-lg-between align-items-center">
                      <label for="agentName" class="col-form-label col-form-label-sm">Salesperson Name</label>
                    </div>
                    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                      <multiselect style="width:100%" v-model="selectedEmployeeData" :options="agentList"
                        :value="agentList.employeeId" :custom-label="displayFullName" selected="selected"
                        @input="retrieveAllDealers(applicationData.source, selectedEmployeeData.employeeId)"
                        id="salesperson">
                      </multiselect>
                    </div>
                  </div>

                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 py-2 mx-0">
                    <div class="col-12 col-md-12 d-flex justify-content-lg-between align-items-center">
                      <label class="col-form-label col-form-label-sm ">Lease Number</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">

                      <input type="search" list="leaseNumberList" class="form-control input-sm"
                        v-model="selectedLeaseNumber">
                      <!-- <datalist id="leaseNumberList">
                        <option    v-for="lease in leaseNumberList" v-bind:value="lease" v-bind:key="lease" >{{lease}}</option>
                     </datalist> -->

                    </div>
                    <div class="col-12 col-md-12 d-flex justify-content-lg-between align-items-center">
                      <label for="dealerName" class="col-form-label col-form-label-sm">Funded Date</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                      <input type="Date" v-model="fundedDate" class="form-control input-sm" />
                    </div>
                  </div>

                  <br>

                  <center>
                    <div class="center mt-2 mb-3">
                      <button type="submit" @click="updateDeals" class="btn btn-secondary">Update</button>&nbsp;&nbsp;

                      <button type="submit" @click="closepopup()" class="btn btn-secondary">Back</button>

                    </div>
                  </center>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="deals" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>View Deals</b>
              </span>
            </nav>
            <br />
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 "><!--row start-->
              <!-- Dealer Name -->
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm ">Dealer Name</label>
               </div>
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">

                  <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="selectedDealerId"
    :options="dealersList"
    :value="dealersList.dealerId"
    :custom-label="displayDealerFullName"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>
               <!-- date range -->
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="quote" class="col-form-label col-form-label-sm required"> Date Range </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="Date" v-model.trim="fromDate" v-validate="'required'" class="form-control input-sm"
                  name="DFrom" data-vv-as="Date Range" />
                <div v-if="errors.has('DFrom')" class="alert-danger"> {{ "Date Range is Mandatory" }} </div>
              </div>
              <div
                class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="Date" v-model.trim="toDate" class="form-control input-sm" v-validate="'required'"
                  name="DFrom" data-vv-as="Date Range" />
              </div>
            </div><!-- row end-->

            <!-- lesse name fraud reason -->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm "> Lessee Name</label>
               </div>
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="selectedCustomerId"
    :options="appCustomersList"
    :value="appCustomersList.customerId"
    :custom-label="displayCustomerFullName"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center" v-if="customerFraudReason!=null">
     <label class="col-form-label col-form-label-sm">Lessee Fraud Reason</label>
    </div>
    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-if="customerFraudReason!=null&& customerFraudReason!='Review'">
      <label style="background-color:Red; text-align:center; float:left" class="col-form-label col-form-label-sm">{{customerFraudReason}}</label>
    </div>
    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-if="customerFraudReason!=null&& customerFraudReason=='Review'">
      <label style="background-color:Orange; text-align:center; float:left" class="col-form-label col-form-label-sm">{{customerFraudReason}}</label>
    </div>
            </div>

            <!-- dealer state sourcce -->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Dealer State</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedDealerState"
                  :options="quoteDealerStateList" :value="quoteDealerStateList.stateFipsC"
                  :custom-label="displayStateFullName" selected="selected" id="customersdd">
                </multiselect>
              </div>
              
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="source" class="col-form-label col-form-label-sm "> Source </label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <!-- <input type="text"  name="source" v-model.trim="selectedappdetails.source" >-->
                     <select name="source" ref="source" v-model.trim="selectedSource" class="form-control input-sm " data-vv-as="Source">
                        <option disabled  value=""> Select a Source</option>
                        <option v-for="(option,index) in sources" :value="option.sourceName" :key="index">{{ option.sourceName }}</option>
                     </select>
                  </div>
            </div>

            <!-- underwriter and sales rep name -->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Underwriter Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedCreditAnalystId"
                  :options="creditAnalystList" :value="creditAnalystList.employeeId"
                  :custom-label="displayFullName" selected="selected" id="creditAnalyst">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Salesperson Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedAgentId"
                :options="agentList" :value="agentList.employeeId" :custom-label="displayFullName"
                  selected="selected" id="customersdd">
                </multiselect>
              </div>
            </div>

            <!-- Lease Number date type -->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 py-2 mx-0">
                    <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                      <label for="leaseNumber" class="col-form-label col-form-label-sm">Lease Number</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                      <select name="changeApp" v-model.trim="leaseNumber" class="form-control input-sm">
                        <option value>Select Lease</option>
                        <option v-for="lease in leaseNumberList" v-bind:value="lease" v-bind:key="lease">{{ lease }}</option>
                      </select>
                    </div>
                    <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                      <label for="Date Type" class="col-form-label col-form-label-sm">Date Type</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                      <select v-model="dateType" class="form-control input-sm">
                        <option v-for="(option, index) in status" :value="option.status" :key="index">{{ option.status }}
                        </option>
                      </select>
                    </div>
                  </div>


            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="stateofReg" class="col-form-label col-form-label-sm ">State of Reg</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                   <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="selectedAppState"
    :options="appStates"
    :value="appStates.stateFipsC"
     :custom-label="displayStateFullName"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm ">Year </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                   <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="appYear"
    :options="appYears"
    :value="appYears"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>

            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="make" class="col-form-label col-form-label-sm ">Make</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="appMake"
    :options="appMakes"
    :value="appMakes"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>

               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center" >
                  <label for="source" class="col-form-label col-form-label-sm ">Model</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="appModel"
    :options="appModels"
    :value="appModels"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm ">App Status </label>
               </div>
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <select v-model.trim="selectedAppStatus" class="form-control input-sm ">
                     <option  value="" > Select App Status </option>
                     <option v-for="status in listAppStatus" :value="status.value" v-bind:key="status.key">{{ status.value}}</option>
                  </select>
               </div>
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm ">Deal Status </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <select v-model.trim="selectedDealStatus" class="form-control input-sm ">
                     <option  value="" > Select Deal Status </option>
                     <option v-for="status in listDealStatus" v-bind:value="status.value" v-bind:key="status.key"> {{ status.value}} </option>
                  </select>
               </div>
            </div>

            <!-- reset show export button -->
            <div class="row row-cols-lg-7 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center">
              <div class="col-12 col-md-12 d-lg-flex justify-content-center align-items-center">
                <download-excel v-model="viewdeals" name="Deals.csv" title="Deals Extract" worksheet="Deals"
                  :fetch="exportdeals" :fields="viewdeals_fields_export" type="csv">
                  <button class="btn btn-secondary mr-3 mb-sm-2 mb-md-2">Export Deals</button>
                </download-excel>
                <div class="d-lg-flex flex-sm-column">
                  <button class="btn btn-secondary mr-3 mb-md-2" type="submit"
                    @click="retrieveApplicationSearchDetails">Show</button>
                </div>
                <div class="d-lg-flex flex-sm-column">
                  <button class="btn btn-secondary mr-3 mb-md-2" type="submit" @click="resetEntries">Reset</button>
                </div>
              </div>
            </div>
            <br />
            <div class="row p-2 justify-content-center">
              <div class="col">
                <div class="table-responsive table-responsive-sm mb-5" style="overflow:auto;">
                  <v-table id="myappsTable" :data="listApps":pageSize="20"
                    @totalPagesChanged="totalPages = $event" class="table table-sm table-bordered table-striped">
                    <thead class="table-month-header-blue wrap-text" slot="head">
                      <v-th>Edit</v-th>
                      <v-th sortKey="appdate">Application Date</v-th>
                      <v-th sortKey="appId">Application Id</v-th>
                      <v-th sortKey="appdate">Lease Number</v-th>
                      <v-th sortKey="proposedLesseeName">Customer Name</v-th>
                      <v-th sortKey="customerFraudReason">Customer Fraud Reason</v-th>
                      <v-th sortKey="businessContactFullName">Business Contact Name</v-th>
                      <v-th sortKey="make">Make</v-th>
                      <v-th sortKey="model">Model</v-th>
                      <v-th sortKey="source">Source</v-th>
                      <v-th sortKey="dealerName">Dealer Name</v-th>
                      <v-th sortKey="dealerFraudReason">Dealer Fraud Reason</v-th>
                      <v-th sortKey="appStatus">Application Status</v-th>
                      <v-th sortKey="appDeclineReason">App Decline Reason</v-th>
                      <v-th sortKey="dealStatus">Deal Status</v-th>
                      <v-th sortKey="fundedDate">Funded Date</v-th>
                      <v-th sortKey="dealDeclineReason">Deal Decline Reason</v-th>
                      <v-th sortKey="quoteState">App State</v-th>
                      <v-th sortKey="quoteId">Quote Number</v-th>
                      <v-th sortKey="salesAgentName">Salesperson Name</v-th>
                      <v-th sortKey="loanAmount">Loan Amount</v-th>

                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr v-for="(app, dindex) in displayData" :key="dindex">
                        <td><button type="submit" class="btn btn-secondary btn-edit"
                            @click="getAppData(app.appId)">Edit</button></td>
                        <td class="table-month-td">{{ app.appDate | moment("MM/DD/YYYY") }}</td>
                        <td class="table-month-td">{{ app.appId }}</td>
                        <td class="table-month-td">{{ app.leaseNumber }}</td>
                        <td class="table-month-td">{{ app.proposedLesseeName }}</td>
                        <td class="table-month-td" v-if="app.customerFraudReason != null && app.customerFraudReason != '' && app.customerFraudReason != 'Review'"
                          style="background-color: Red">{{ app.customerFraudReason }}</td>
                        <td class="table-month-td" v-if="app.customerFraudReason != null && app.customerFraudReason != '' && app.customerFraudReason == 'Review'"
                          style="background-color: Orange">{{ app.customerFraudReason }}</td>
                        <td class="table-month-td" v-if="app.customerFraudReason == null || app.customerFraudReason == ''">{{ app.customerFraudReason }}</td>
                        <td class="table-month-td">{{ app.businessContactFullName }}</td>
                        <td class="table-month-td">{{ app.make }}</td>
                        <td class="table-month-td">{{ app.model }}</td>
                        <td class="table-month-td">{{ app.source }}</td>
                        <td class="table-month-td">{{ app.dealerName }}</td>
                        <td class="table-month-td" v-if="app.dealerFraudReason != null && app.dealerFraudReason != '' && app.dealerFraudReason != 'Review'"
                          style="background-color: Red">{{ app.dealerFraudReason }}</td>
                        <td class="table-month-td" v-if="app.dealerFraudReason != null && app.dealerFraudReason != '' && app.dealerFraudReason == 'Review'"
                          style="background-color: Orange">{{ app.dealerFraudReason }}</td>
                        <td class="table-month-td" v-if="app.dealerFraudReason == null || app.dealerFraudReason == ''">{{ app.dealerFraudReason }}</td>
                        <td class="table-month-td">{{ app.appStatus }}</td>
                        <td class="table-month-td">{{ app.appDeclineReason }}</td>
                        <td class="table-month-td">{{ app.dealStatus }}</td>
                        <td class="table-month-td">{{ app.fundedDate | moment("MM/DD/YYYY") }}</td>
                        <td class="table-month-td">{{ app.dealDeclineReason }}</td>
                        <td class="table-month-td">{{ app.quoteState }}</td>
                        <td class="table-month-td">{{ app.quoteId }}</td>
                        <td class="table-month-td">{{ app.salesAgentName }}</td>
                        <td class="table-month-td">{{ app.loanAmount }}</td>

                      </tr>
                    </tbody>
                  </v-table>
                  <!-- <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages"
                    :style="{ listStyle: none }" /> -->
                  
                </div>
                <b-pagination v-if="totalPages > 0"  
                      align="right"
                      v-model="currentPage"
                      :total-rows="totalElements"
                      :per-page="perPage"
                      aria-controls="myappsTable"
                      @change="handleClick($event)"
                      :class="{ 'd-none': isLoading || listApps.length == 0 }">
                    </b-pagination>
                    <template v-if="listApps.length == 0 && !isLoading">
                      <center>
                          <span>
                              <b>No records found</b>
                              <br />
                          </span>
                      </center>
                  </template>
                  <template v-if="isLoading">
                        <div class="d-flex justify-content-center align-items-center">
                          <strong>Loading...</strong>
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
                  </template>
              </div>
            </div>
          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpsource from '../js/http-managesource.js'
import httpemployee from '../js/http-employee.js'
import httpcustomer from '../js/http-customer.js'
import dealsjson from '../json/quotes.json'
import lookup from '../prod-json/lookupvalues.json'
import httpdeal from '../js/http-dealstracking.js'
import util from '../js/common-utils'
import moment from 'moment'
export default {
  components: { MainMenu, TopHeader, BottomFooter },
  data () {
    return {
      msgcolor: {
        color: 'green'
      },
      sources: [
        { sourceName: 'Dealer' },
        { sourceName: 'InHouse' }
      ],
      rows: 0,
      leaseMessage: '',
      selectedLeaseNumber: '',
      fundedDate: '',
      message: '',
      displayLeaseNumber: '',
      firstName: this.$session.get('first_name'),
      middleName: this.$session.get('middle_name'),
      lastName: this.$session.get('last_name'),
      empId: this.$session.get('employee_id'),
      userRole: this.$session.get('user_role'),
      source: '',
      name: 'Pagination',
      popUpType: '',
      viewdeals: 'downloadviewdeals',
      appStatusList: [],
      agentList: [],
      activeAgentList: [],
      creditAnalystList: [],
      currentPage: 1,
      totalPages: 0,
      dealStatus: '',
      leaseNumber: '',
      appStatus: '',
      dateTypeList: [
        { name: 'AppDate', value: 'App Date' },
        { name: 'FundedDate', value: 'Funded Date' }
      ],
      leaseNumberList: [],
      applicationData: this.initializedata(),
      selectedDealerData: '',
      selectedCustomerData: '',
      selectedEmployeeData: '',
      selectedCreditAnalystData: '',
      dealersList: [],
      appCustomersList: [],
      heads: [
        { name: 'Application Date' },
        { name: 'Customer Name' },
        { name: 'Customer Fraud Reason' },
        { name: 'Business Contact Name' },
        { name: 'Make' },
        { name: 'Model' },
        { name: 'Source' },
        { name: 'Dealer Name' },
        { name: 'Application Status' },
        { name: 'App Decline Reason' },
        { name: 'Deal Status' },
        { name: 'Funded Date' },
        { name: 'Deal Decline Reason' },
        { name: 'App State' },
        { name: 'Quote Number' },
        { name: 'Salesperson Name' },
        { name: 'Loan Amount' }
      ],
      listApps: [],
      viewdeals_fields_export: {
        'Application Date': 'appDate',
        'Customer Name': 'proposedLesseeName',
        'Business Contact Name': 'businessContactFullName',
        Make: 'make',
        Model: 'model',
        Source: 'source',
        'Dealer Name': 'dealerName',
        'Application Status': 'appStatus',
        'Application Decline Reason': 'appDeclineReason',
        'Deal Status': 'dealStatus',
        'Funded Date': 'fundedDate',
        'Deal Decline Reason': 'dealDeclineReason',
        'App State': 'quoteState',
        'Quote Number': 'quoteId',
        'Salesperson Name': 'salesAgentName',
        'Loan Amount': 'loanAmount'
      },
      fromDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      quoteDealerStateList: [],
      selectedDealerState: "",
      quoteAgentsList: [],
      quoteCreditAnalystList: [],
      selectedCreditAnalystId: '',
      selectedAgentId: '',
      leaseNumber: '',
      status: [
        { status: 'AppDate' },
        { status: 'FundedDate' },
      ],
      listAppStatus: lookup[0].lookupValues,
      appStates: [],
      appYears: [],
      appMakes: [],
      appModels: [],
      listDealStatus: lookup[0].lookupValues,
      dateType: '',
      selectedSource: '',
      leaseNumberList: [],
      selectedCreditAnalystData: '',
      totalElements: 0,
      isLoading: false,
      perPage: 10,
      selectedDealStatus: '',
      selectedDealerId: '',
      selectedCustomerId: '',
      selectedAppState: '',
      selectedAppStatus: '',
      appYear: '',
      appMake: '',
      appModel: '',
      customerFraudReason: null,
    }
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
    this.fromDate = moment().subtract(60, 'days').format('YYYY-MM-DD')
    this.toDate = moment().format('YYYY-MM-DD')
  },
  computed: {
    sortedDealers: function () {
      return this.dealersList.sort((a, b) => { return a.dealerName > b.dealerName ? 1 : -1 })
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  methods: {
    closepopup () {
      this.popUpType = false
    },

    enablePopUp () {
      this.popUpType = 'viewDeals'
    },
    resetEntries () {
      if (this.userRole == 'AD' || this.userRole == 'BO') this.source = ''
      this.fromDate = moment().subtract(60, 'days').format('YYYY-MM-DD')
      this.toDate = moment().format('YYYY-MM-DD')
      this.appStatus = ''
      this.dealStatus = ''
      this.dateType = ''
      this.leaseNumber = ''
      this.selectedDealStatus = ''
      this.selectedDealerId = ''
      this.selectedCustomerId = ''
      this.selectedAppState = ''
      this.selectedAppStatus = ''
      this.appYear = ''
      this.appMake = ''
      this.appModel = ''
      this.customerFraudReason = null
      this.selectedapp = ''
      this.selectedDealerState = "";
      this.selectedCreditAnalystId = '';
      this.selectedAgentId = '';
      this.selectedSource = '';
      this.selectedCreditAnalystData = '';
      this.retrieveApplicationSearchDetails()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#deals').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    fetchData () {
      this.retrieveAllDealers()
      this.retrieveAllStates()
      this.retrieveAllYears()
      this.retrieveAllMakes()
      this.retrieveAllModels()
      this.retriveQuoteDealerStateList()
      // this.retriveQuoteEmployeeList()
      this.retrieveSalesPersonList()
      // this.retrieveAppStatus()
      this.retrieveLeaseNumber()
      // this.retrieveAllDealers(this.applicationData.source,this.selectedEmployeeData.employeeId);
      this.retrieveAllLesseeNames()
      if (this.userRole == 'AD' || this.userRole == 'BO') {
        this.retrieveAgentList(),
        this.retrieveActiveAgentList()
      } else {
        this.source = this.empId
      }
      this.retrieveApplicationSearchDetails()
    },
    displayDealerFullName (option) {
      return `${option.dealerName}`
    },
    displayFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },

    displayCustomerFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    getDealerDetails (dealerId) {
      if (dealerId >= 0) {
        httpsource.get('/dealerbyid/' + dealerId).then(response => {
          var dealerlist = response.data

          this.selectedDealerData = dealerlist
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getAgentDetails (employeeId, role) {
      if (employeeId >= 0) {
        httpemployee.get('/employee/' + employeeId).then(response => {
          var employeelist = response.data
          if (role === 'SR') {
            this.selectedEmployeeData = employeelist[0]
          }
          if (role === 'CA') {
            this.selectedCreditAnalystData = employeelist[0]
          }
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getCustomerDetails (customerId) {
      if (customerId >= 0) {
        httpcustomer.get('/customer/' + customerId).then(response => {
          var customerlist = response.data
          var customerobject = customerlist[0]
          this.selectedCustomerData = customerobject
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },

    retrieveAllLesseeNames: function () {
      httpcustomer.get('/customer/').then(response => {
        this.appCustomersList = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllDealers: function (source, employeeId) {
      this.dealersList = []
      if (source == 'InHouse') {
        httpsource.get('/dealersearch').then(response => {
          if (response.data.length != 0) {
            this.dealersList = []
            this.dealersList = response.data
          }
        })
          .catch(error => {
            console.log('Failed to load dealers:' + error)
          })
      } else if (employeeId != '') {
        httpemployee.get('/employee/' + parseInt(employeeId)).then(response => {
          this.dealersList = []

          // this.selectedDealerData=''

          for (var i = 0; i < response.data.length; i++) {
            var employeeobject = response.data[i]
            for (var i = 0; i < employeeobject.empBusinessCoverageAreas.length; i++) {
              var empbuscovarea = employeeobject.empBusinessCoverageAreas[i]
              this.dealersList.push({
                'dealerId': empbuscovarea.id.dealerId,
                'dealerName': empbuscovarea.ddealerInfo.dealerName
              })
            }
          }
        }).catch(e => { console.log(e) })
      }
    },

    retrieveAgentList: function () {
      httpdeal
        .get('/application/appsalesagents')
        .then(response => {
          this.agentList = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    retrieveActiveAgentList () {
      let searchEmployee = this.createSearchObject()
      httpemployee.post('/employee/search/', searchEmployee).then(response => {
        if (response.data.length > 0) {
          // this.agentList = response.data.filter((employee) => {
          //   return employee.userRoleC !== 'CA'
          // })
          // this.creditAnalystList = response.data.filter((employee) => {
          //   return employee.userRoleC === 'CA'
          // })
          this.agentList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'SR');
          })
          this.creditAnalystList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'CA');
          })
        }
      })
        .catch(e => {
          this.errorslist.push(e)
        })
    },

    createSearchObject () {
      return {
        'firstName': '',
        'lastName': '',
        'roleType': '',
        'statusCode': 'A'
      }
    },
    initializedata () {
      return {
        appId: '',
        year: '',
        make: '',
        model: '',
        source: '',
        customerId: '',
        dealerId: ''

      }
    },

    getAppData (value) {
      this.message = ''
      this.displayLeaseNumber = ''
      this.enablePopUp()
      this.selectedDealerData = ''
      this.selectedCustomerData = ''
      this.selectedEmployeeData = ''

      httpdeal
        .get('/application/getById?appId=' + value)
        .then(response => {
          this.applicationData = {
            year: response.data.year,
            make: response.data.make,
            model: response.data.model,
            source: response.data.source,
            appId: value

          }

          this.retrieveAllDealers(response.data.source, response.data.salesAgent)

          if (response.data.dealerId != null) {
            // this.selectedDealerData = response.data
            this.getDealerDetails(response.data.dealerId)
          }
          if (response.data.customerId != null) {
            // this.selectedCustomerData= response.data
            this.getCustomerDetails(response.data.customerId)
          }
          if (response.data.salesAgent != null && response.data.salesAgent !== '') {
            this.getAgentDetails(response.data.salesAgent, 'SR')
          }

          if (response.data.creditAnalystId > 0) {
            this.getAgentDetails(response.data.creditAnalystId, 'CA')
          }

          if (response.data.leaseNumber != null) {
            this.displayLeaseNumber = response.data.leaseNumber
            this.selectedLeaseNumber = response.data.leaseNumber
          }

          if (response.data.fundedDate) {
            this.fundedDate = moment(response.data.fundedDate).format('YYYY-MM-DD')
            console.log(this.fundedDate, 'momenttt')
          }

          if (response.data.leaseNumber == null) {
            this.displayLeaseNumber = 'Not Available'
          }
        })
    },

    updateDeals () {
      let updateDealPayload = {
        appId: this.applicationData.appId,
        make: this.applicationData.make,
        model: this.applicationData.model,
        year: this.applicationData.year,
        source: this.applicationData.source,
        customerId: this.selectedCustomerData.customerId,
        salesAgent: this.selectedEmployeeData.employeeId,
        creditAnalystId: this.selectedCreditAnalystData.employeeId,
        dealerId: this.selectedDealerData.dealerId,
        leaseNumber: this.selectedLeaseNumber,
        fundedDate: this.fundedDate ? util.formatDateMoment(moment(this.fundedDate)) : ''

      }

      // if (this.fromDate != null) { frmDt = util.formatDateMoment(moment(this.fromDate)) } else frmDt = this.fromDate

      httpdeal.put('/application/updateApplication', updateDealPayload).then((response) => {
        var status = response.data
        if (status == 'ACCEPTED') {
          this.msgcolor.color = 'Green'
          this.message = 'Deal has been updated successfully!!!'
          this.resetEntries()
          this.retrieveApplicationSearchDetails()
          setTimeout(() => { this.closepopup() }, 3000)
        }
        if (status == 'Duplicate Lease Number') {
          this.msgcolor.color = 'Red'
          this.message = ' ERROR: Duplicate Lease Number'
        }
      })
    },

    retrieveApplicationDetails () {
      this.selectedLeaseNumber = ''
      var frmDt, toDt
      if (this.fromDate != null) { frmDt = util.formatDateMoment(moment(this.fromDate)) } else frmDt = this.fromDate
      if (this.toDate != null) { toDt = util.formatDateMoment(moment(this.toDate)) } else toDt = this.toDate
      var src = ''
      var agentID = ''
      if (this.source == 'InHouse') {
        src = 'InHouse'
        agentID = ''
      } else {
        src = ''
        agentID = this.source
      }

      let viewDealsPayload = {
        source: src,
        salesRepName: agentID,
        fromDate: frmDt,
        toDate: toDt,
        appStatus: this.appStatus,
        dealStatus: this.dealStatus,
        dateType: this.dateType,
        leaseNumber: this.leaseNumber
      }
      console.log('viewDealsPayload')
      console.log(viewDealsPayload)
      httpdeal.post('/application/search', viewDealsPayload).then(response => {
        this.listApps = response.data
        this.rows = this.listApps.length

        // httpdeal
        //   .post(endpoint, {
        //     requestBody // Pass requestBody if it's not null
        //   })
        //   .then(response => {
        //     fraudreason = response.data
        //     if (arr == '') {
        //       this.listApps = listApps1
        //     }

        //     for (j = 0; j < listApps1.length; j++) {
        //       for (var k = 0; k < fraudreason.length; k++) {
        //         if (listApps1[j].customerId == fraudreason[k].customerId) {
        //           if (fraudreason[k].customerFraudReason != '') {
        //             listApps1[j]['fraudreason'] =
        //               fraudreason[k].customerFraudReason
        //           } else listApps1[j]['fraudreason'] = null
        //         }
        //       }

        //       this.listApps = listApps1
        //     }
        //   })
        //   .catch(e => {
        //     this.errors.push(e)
        //   })
      })
    },

    // Export View deals
    async exportdeals () {
      var frmDt, toDt
      if (this.fromDate != null) { frmDt = util.formatDateMoment(moment(this.fromDate)) } else frmDt = this.fromDate
      if (this.toDate != null) { toDt = util.formatDateMoment(moment(this.toDate)) } else toDt = this.toDate
      var src = ''
      var agentID = ''
      if (this.source == 'InHouse') {
        src = 'InHouse'
        agentID = ''
      } else {
        src = ''
        agentID = this.source
      }

      let viewDealsPayload = {
        source: src,
        salesRepName: agentID,
        fromDate: frmDt,
        toDate: toDt,
        appStatus: this.appStatus,
        dealStatus: this.dealStatus,
        dateType: this.dateType
      }
      const response = await httpdeal.post('/application/search', viewDealsPayload,{params: {'page': this.currentPage - 1, 'size': 100000,isExport: true}})
      // this.listApps= response.data
      return response.data
    },

    retrieveAppStatus: function () {
      httpdeal
        .get('/application/appstatus')
        .then(response => {
          this.appStatusList = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    retrieveLeaseNumber: function () {
      httpdeal
        .get('/application/appLeaseNumber')
        .then(response => {
          this.leaseNumberList = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    // filter application

    retrieveSalesPersonList () {
      let searchEmployee = this.createSearchObject()
      httpemployee.post('/employee/search/', searchEmployee).then(response => {
        // this.agentList = response.data
        this.agentList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'SR');
          })
          
          this.creditAnalystList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'CA');
          })
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllDealers: function () {
      httpdeal.get('/application/dealers').then(response => {
        this.dealersList = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllLesseeNames: function () {
      httpdeal.get('/application/customers').then(response => {
        this.appCustomersList = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllStates: function () {
      httpdeal.get('/application/appstate').then(response => {
        this.appStates = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllYears: function () {
      httpdeal.get('/application/lmyears').then(response => {
        this.appYears = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllMakes: function () {
      httpdeal.get('/application/lmmake').then(response => {
        this.appMakes = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllModels: function () {
      httpdeal.get('/application/lmmodel').then(response => {
        this.appModels = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    // retrieveAllDealStatus: function () {
    //   httpdeal.get('/application/appdealstatus').then(response => {
    //     this.listDealStatus = response.data
    //   })
    //     .catch(e => {
    //       this.errors.push(e)
    //     })
    // },

    // application filter 

    
    async retrieveApplicationSearchDetails() {
      console.log('search clicked')
      this.isLoading = true
      const payload = {
        "source": this.selectedSource,
        "salesRepName": this.selectedAgentId.employeeId || null,
        // "fromDate": null,
        // "toDate": null,
        "fromDate": this.fromDate || null,
        "toDate": this.toDate || null,
        "appStatus": this.selectedAppStatus || "",
        "dealStatus": this.selectedDealStatus || "",
        // "dealStatus": "Approved",
        "dateType": this.dateType || "",
        // "dateType": "AppDate",
        "leaseNumber": this.leaseNumber || "",
        "creditAnalystId": this.selectedCreditAnalystId.employeeId || null,
        "dealerState":  this.selectedDealerState.stateFipsC || "",
        "year": this.appYear || null,
        "make": this.appMake || "",
        "model": this.appModel || "",
        "stateOfReg": this.selectedAppState.stateFipsC || "",
        "customerId": this.selectedCustomerId.customerId || null,
        "dealerId": this.selectedDealerId.dealerId || null
    }
      await httpdeal.post('/application/search', payload, {params: {'page': this.currentPage - 1, 'size': 10}}).then( async response => {
        if (response.data.errorMessage != null && response.data.errorMessage.length > 0) {
          this.listApps = []
        } else {
          var arr = []
          var j = 0
          var fraudreason = []
          var listApps1 = []
          var listApps1 = response.data.content
          for (var i = 0; i < listApps1.length; i++) {
            arr.push(listApps1[i].customerId)
          }
          await httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + arr).then(response => {
            fraudreason = response.data
            for (j = 0; j < listApps1.length; j++) {
              for (var k = 0; k < fraudreason.length; k++) {
                if (listApps1[j].customerId == fraudreason[k].customerId) {
                  if (fraudreason[k].customerFraudReason != '') { listApps1[j]['fraudreason'] = fraudreason[k].customerFraudReason } else { listApps1[j]['fraudreason'] = null }
                }
              }
            }
            this.listApps = listApps1
          })
          this.totalElements = response.data.totalElements
          this.totalPages = response.data.totalPages
        }
        this.isLoading = false
      })

        .catch(e => {
          this.isLoading = false
          this.errors.push(e)
        })
    },

    retriveQuoteDealerStateList () {
      httpdeal.get('/quote/quotedealerstate').then(response => {
        this.quoteDealerStateList = response.data
      })
    },

    // retriveQuoteEmployeeList () {
    //   httpdeal.get('/quote/quoteemployees').then(response => {
    //     if (response.data.length > 0) {
    //       this.quoteAgentsList = response.data.filter((employee) => {
    //         return employee.userRoleC == 'SR'
    //       })
    //       this.quoteCreditAnalystList = response.data.filter((employee) => {
    //         return employee.userRoleC == 'CA'
    //       })
    //     }
    //   })
    // },


    handleClick (event) {
      this.currentPage = event
      this.retrieveApplicationSearchDetails()
    },

    
    displayStateFullName (option) {
      return `${option.stateN}`
    },

    filterApplicationDetails: function () { }
  }
}
</script>

<style scoped>
.wrap-text {
  white-space: nowrap;
}

.card {
  padding: -5px !important;
  margin: 0 auto;
}

@media screen and (max-width : 600px) {
  .card {
    margin-top: 4%;
  }
}

.postmodalcontent {
  border: none !important;
}

.btn:focus {
  box-shadow: none;
}

.modal-header {
  border: none;
}

.bodymodal11 {
  padding: 0 !important;
  height: 80vh;
  overflow-y: auto;

}

.bodymodal11 {
  background-color: white;
}

.profile-border {
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}

.close {
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}

.close:hover {
  background-color: rgba(161, 166, 179, 0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179, .5);
}

.modal-backdrop {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000 !important;
}

.btn-edit {
  font-size: 12px;
  padding: 0.2rem 0.75rem;
}

thead {
  position: sticky;
  top: 0px;
  /* 0px if you don't have a navbar, but something is required */

}
</style>
